import aspectRatio from "./pagesData/layouts/aspect-ratio";
import breakAfter from "./pagesData/layouts/break-after";
import breakBefore from "./pagesData/layouts/break-before";
import boxDecorationBreak from "./pagesData/layouts/box-decoration-break";
import breakInside from "./pagesData/layouts/break-inside";
import columns from "./pagesData/layouts/columns";
import boxSizing from "./pagesData/layouts/box-sizing";
import display from "./pagesData/layouts/display";
import float from "./pagesData/layouts/float";
import clear from "./pagesData/layouts/clear";
import isolation from "./pagesData/layouts/isolation";
import objectFit from "./pagesData/layouts/object-fit";
import objectPosition from "./pagesData/layouts/object-position";
import overflow from "./pagesData/layouts/overflow";
import overscrollBehavior from "./pagesData/layouts/overscroll-behavior";
import position from "./pagesData/layouts/position";
import topRightBottomLeft from "./pagesData/layouts/top-right-bottom-left";
import visibility from "./pagesData/layouts/visibility";
import zIndex from "./pagesData/layouts/z-index";
import flexbasis from "./pagesData/flexGrid/flex-basis";
import flexDirection from "./pagesData/flexGrid/flex-direction";
import flexWrap from "./pagesData/flexGrid/flex-wrap";
import flex from "./pagesData/flexGrid/flex";
import flexGrow from "./pagesData/flexGrid/flex-grow";
import flexShrink from "./pagesData/flexGrid/flex-shrink";
import order from "./pagesData/flexGrid/order";
import gridTemplateColumns from "./pagesData/flexGrid/grid-template-columns";
import gridColumns from "./pagesData/flexGrid/grid-column";
import gridTemplateRow from "./pagesData/flexGrid/grid-template-rows";
import gridRow from "./pagesData/flexGrid/grid-row";
import gridAutoFlow from "./pagesData/flexGrid/grid-auto-flow";
import gridAutoColumns from "./pagesData/flexGrid/grid-auto-columns";
import gridAutoRows from "./pagesData/flexGrid/grid-auto-rows";
import gap from "./pagesData/flexGrid/gap";
import justifyContent from "./pagesData/flexGrid/justify-content";
import justifyItems from "./pagesData/flexGrid/justify-items";
import justifySelf from "./pagesData/flexGrid/justify-self";
import alignContent from "./pagesData/flexGrid/align-content";
import alignItems from "./pagesData/flexGrid/align-items";
import alignSelf from "./pagesData/flexGrid/align-self";
import placeContent from "./pagesData/flexGrid/place-content";
import placeItems from "./pagesData/flexGrid/place-items";
import placeSelf from "./pagesData/flexGrid/place-self";
import padding from "./pagesData/spacing/padding";
import margin from "./pagesData/spacing/margin";
import width from "./pagesData/sizing/width";
import minWidth from "./pagesData/sizing/min-width";
import maxWidth from "./pagesData/sizing/max-width";
import height from "./pagesData/sizing/height";
import minHeight from "./pagesData/sizing/min-height";
import maxHeight from "./pagesData/sizing/max-height";
import fontFamily from "./pagesData/typography/font-family";
import fontSize from "./pagesData/typography/font-size";
import fontSmoothing from "./pagesData/typography/font-smoothing";
import fontStyle from "./pagesData/typography/font-style";
import fontWeight from "./pagesData/typography/font-weight";
import fontStretch from "./pagesData/typography/font-stretch";
import fontVariantNumeric from "./pagesData/typography/font-variant-numeric";
import letterSpacing from "./pagesData/typography/letter-spacing";
import lineClamp from "./pagesData/typography/line-clamp";
import lineHeight from "./pagesData/typography/line-height";
import listStyleImage from "./pagesData/typography/list-style-image";
import listStylePosition from "./pagesData/typography/list-style-position";
import listStyleType from "./pagesData/typography/list-style-type";
import textAlign from "./pagesData/typography/text-align";
import color from "./pagesData/typography/color";
import textDecorationLine from "./pagesData/typography/text-decoration-line";
import textDecorationColor from "./pagesData/typography/text-decoration-color";
import textDecorationStyle from "./pagesData/typography/text-decoration-style";
import textDecorationThickness from "./pagesData/typography/text-decoration-thickness";
import textUnderlineOffset from "./pagesData/typography/text-underline-offset";
import textTransform from "./pagesData/typography/text-transform";
import textOverflow from "./pagesData/typography/text-overflow";
import textWrap from "./pagesData/typography/text-wrap";
import textIndent from "./pagesData/typography/text-indent";
import verticalAlign from "./pagesData/typography/vertical-align";
import whiteSpace from "./pagesData/typography/white-space";
import wordBreak from "./pagesData/typography/word-break";
import overflowWrap from "./pagesData/typography/overflow-wrap";
import hyphens from "./pagesData/typography/hyphens";
import content from "./pagesData/typography/content";
import direction from "./pagesData/typography/direction";
import backgroundAttachment from "./pagesData/backgrounds/background-attachment";
import backgroundClip from "./pagesData/backgrounds/background-clip";
import backgroundColor from "./pagesData/backgrounds/background-color";
import backgroundImage from "./pagesData/backgrounds/background-image";
import backgroundOrigin from "./pagesData/backgrounds/background-origin";
import backgroundPosition from "./pagesData/backgrounds/background-position";
import backgroundRepeat from "./pagesData/backgrounds/background-repeat";
import backgroundSize from "./pagesData/backgrounds/background-size";
import borderRadius from "./pagesData/borders/border-radius";
import borderwidth from "./pagesData/borders/border-width";
import borderColor from "./pagesData/borders/border-color";
import outlinewidth from "./pagesData/borders/outline-width";
import outlineColor from "./pagesData/borders/outline-color";
import outlineStyle from "./pagesData/borders/outline-style";
import borderStyle from "./pagesData/borders/border-style";
import outlineOffset from "./pagesData/borders/outline-offset";
import blur from "./pagesData/filters/blur";
import brightness from "./pagesData/filters/brightness";
import contrast from "./pagesData/filters/contrast";
import dropShadow from "./pagesData/filters/drop-shadow";
import grayscale from "./pagesData/filters/grayscale";
import hueRotate from "./pagesData/filters/hue-rotate";
import invert from "./pagesData/filters/invert";
import saturate from "./pagesData/filters/saturate";
import sepia from "./pagesData/filters/sepia";
import backdropBlur from "./pagesData/filters/backdrop-blur";
import backdropBrightness from "./pagesData/filters/backdrop-brightness";
import backdropContrast from "./pagesData/filters/backdrop-contrast";
import backdropGrayscale from "./pagesData/filters/backdrop-grayscale";
import backdropHueRotate from "./pagesData/filters/backdrop-hue-rotate";
import backdropInvert from "./pagesData/filters/backdrop-invert";
import backdropOpacity from "./pagesData/filters/backdrop-opacity";
import backdropSaturate from "./pagesData/filters/backdrop-saturate";
import backdropSepia from "./pagesData/filters/backdrop-sepia";
import borderCollapse from "./pagesData/tables/border-collapse";
import borderSpacing from "./pagesData/tables/border-spacing";
import tableLayout from "./pagesData/tables/table-layout";
import captionSide from "./pagesData/tables/caption-side";
import transitionProperty from "./pagesData/transitions/transition-property";
import transitionBehavior from "./pagesData/transitions/transition-behavior";
import transitionDuration from "./pagesData/transitions/transition-duration";
import transitionTimingFunction from "./pagesData/transitions/transition-timing-function";
import transitionDelay from "./pagesData/transitions/transition-delay";
import animation from "./pagesData/transitions/animation";
import animationIterationCount from "./pagesData/transitions/animation-iteration-count";
import backfaceVisibility from "./pagesData/transforms/backface-visibility";
import perspective from "./pagesData/transforms/perspective";
import perspectiveOrigin from "./pagesData/transforms/perspective-origin";
import rotate from "./pagesData/transforms/rotate";
import scale from "./pagesData/transforms/scale";
import skew from "./pagesData/transforms/skew";
import transform from "./pagesData/transforms/transform";
import transformOrigin from "./pagesData/transforms/transform-origin";
import transformStyle from "./pagesData/transforms/transform-style";
import translate from "./pagesData/transforms/translate";
import accentColor from "./pagesData/interactivity/accent-color";
import appearance from "./pagesData/interactivity/appearance";
import caretColor from "./pagesData/interactivity/caret-color";
import colorScheme from "./pagesData/interactivity/color-scheme";
import cursor from "./pagesData/interactivity/cursor";
import fieldSizing from "./pagesData/interactivity/field-sizing";
import pointerEvents from "./pagesData/interactivity/pointer-events";
import boxShadow from "./pagesData/effects/box-shadow";
import textShadow from "./pagesData/effects/text-shadow";
import opacity from "./pagesData/effects/opacity";
import mixBlendMode from "./pagesData/effects/mix-blend-mode";
import backgroundBlendMode from "./pagesData/effects/background-blend-mode";
import maskClip from "./pagesData/effects/mask-clip";
import maskComposite from "./pagesData/effects/mask-composite";
import maskImage from "./pagesData/effects/mask-image";
import maskMode from "./pagesData/effects/mask-mode";
import maskOrigin from "./pagesData/effects/mask-origin";
import maskPosition from "./pagesData/effects/mask-position";
import maskRepeat from "./pagesData/effects/mask-repeat";
import maskSize from "./pagesData/effects/mask-size";
import resize from "./pagesData/interactivity/resize";
import scrollBehavior from "./pagesData/interactivity/scroll-behavior";
import scrollMargin from "./pagesData/interactivity/scroll-margin";
import scrollPadding from "./pagesData/interactivity/scroll-padding";
import scrollSnapAlign from "./pagesData/interactivity/scroll-snap-align";
import scrollSnapStop from "./pagesData/interactivity/scroll-snap-stop";
import scrollSnapType from "./pagesData/interactivity/scroll-snap-type";
import touchAction from "./pagesData/interactivity/touch-action";
import userSelect from "./pagesData/interactivity/user-select";
import fill from "./pagesData/svg/fill";
import stroke from "./pagesData/svg/stroke";
import strokeWidth from "./pagesData/svg/stroke-width";
import installation from "./pagesData/gettingStarted/installation";
import compatibility from "./pagesData/gettingStarted/compatibility";
import styleWithUtilityClasses from "./pagesData/coreConcepts/styling-with-utility-classes";
import hoverFocusAndOtherStates from "./pagesData/coreConcepts/hover-focus-and-other-states";
import responsiveDesign from "./pagesData/coreConcepts/responsive-design";
import darkMode from "./pagesData/coreConcepts/dark-mode";
import colors from "./pagesData/coreConcepts/colors";
import addingCustomStyles from "./pagesData/coreConcepts/adding-custom-styles";
import detectingClassesInSourceFiles from "./pagesData/coreConcepts/detecting-classes-in-source-files";
import willChange from "./pagesData/interactivity/will-chnage";

const pagesData = [
    {
        section: "Getting started",
        pages: [
            installation,
            compatibility
        ]
    },
    {
        section: "Core concepts",
        pages: [
            styleWithUtilityClasses,
            hoverFocusAndOtherStates,
            responsiveDesign,
            darkMode,
            colors,
            addingCustomStyles,
            detectingClassesInSourceFiles
        ]
    },
    {
        section: "Layout",
        pages: [
            aspectRatio,
            columns,
            breakAfter,
            breakBefore,
            breakInside,
            boxDecorationBreak,
            boxSizing,
            display,
            float,
            clear,
            isolation,
            objectFit,
            objectPosition,
            overflow,
            overscrollBehavior,
            position,
            topRightBottomLeft,
            visibility,
            zIndex
        ],
    },
    {
        section: "Flexbox & Grid",
        pages: [
            flexbasis,
            flexDirection,
            flexWrap,
            flex,
            flexGrow,
            flexShrink,
            order,
            gridTemplateColumns,
            gridColumns,
            gridTemplateRow,
            gridRow,
            gridAutoFlow,
            gridAutoColumns,
            gridAutoRows,
            gap,
            justifyContent,
            justifyItems,
            justifySelf,
            alignContent,
            alignItems,
            alignSelf,
            placeContent,
            placeItems,
            placeSelf
        ],
    },
    {
        section: "Spacing",
        pages: [padding, margin]
    },
    {
        section: "Sizing",
        pages: [width, minWidth, maxWidth, height, minHeight, maxHeight]
    },
    {
        section: "Typography",
        pages: [
            fontFamily,
            fontSize,
            fontSmoothing,
            fontStyle,
            fontWeight,
            fontStretch,
            fontVariantNumeric,
            letterSpacing,
            lineClamp,
            lineHeight,
            listStyleImage,
            listStylePosition,
            listStyleType,
            textAlign,
            color,
            textDecorationLine,
            textDecorationColor,
            textDecorationStyle,
            textDecorationThickness,
            textUnderlineOffset,
            textTransform,
            textOverflow,
            textWrap,
            textIndent,
            verticalAlign,
            whiteSpace,
            wordBreak,
            overflowWrap,
            hyphens,
            content,
            direction
        ]
    },
    {
        section: "Backgrounds",
        pages: [backgroundAttachment, backgroundClip, backgroundColor, backgroundImage, backgroundOrigin, backgroundPosition, backgroundRepeat, backgroundSize]
    },
    {
        section: "Borders",
        pages: [borderRadius, borderwidth, borderColor, borderStyle, outlinewidth, outlineColor, outlineStyle, outlineOffset]
    },
    {
        section: "Effects",
        pages: [
            boxShadow,
            textShadow,
            opacity,
            mixBlendMode,
            backgroundBlendMode,
            maskClip,
            maskComposite,
            maskImage,
            maskMode,
            maskOrigin,
            maskPosition,
            maskRepeat,
            maskSize
        ]
    },
    {
        section: "Filters",
        pages: [
            blur,
            brightness,
            contrast,
            dropShadow,
            grayscale,
            hueRotate,
            invert,
            saturate,
            sepia,
            backdropBlur,
            backdropBrightness,
            backdropContrast,
            backdropGrayscale,
            backdropHueRotate,
            backdropInvert,
            backdropOpacity,
            backdropSaturate,
            backdropSepia
        ]
    },
    {
        section: "Tables",
        pages: [borderCollapse,borderSpacing,tableLayout,captionSide]
    },
    {
        section: "Transitions & Animation",
        pages: [transitionProperty,transitionBehavior,transitionDuration,transitionTimingFunction,transitionDelay,animation,animationIterationCount]
    },
    {
        section: "Transforms",
        pages: [
            backfaceVisibility,
            perspective,
            perspectiveOrigin,
            rotate,
            scale,
            skew,
            transform,
            transformOrigin,
            transformStyle,
            translate
        ]
    },
    {
        section: "Interactivity",
        pages: [
            accentColor,
            appearance,
            caretColor,
            colorScheme,
            cursor,
            fieldSizing,
            pointerEvents,
            resize,
            scrollBehavior,
            scrollMargin,
            scrollPadding,
            scrollSnapAlign,
            scrollSnapStop,
            scrollSnapType,
            touchAction,
            userSelect,
            willChange
        ]
    },
    {
        section: "SVG",
        pages: [
            fill,
            stroke,
            strokeWidth
        ]
    },
];

export default pagesData;
